export default "__VITE_ASSET__CboU1IC1__"